import { IVoucher } from '@checkout/state';
import * as React from 'react';
import { Button } from '..';
import * as Styles from './VoucherList.scss';

interface IOwnProps {
  vouchers: IVoucher[];
  removeLabel: string;
  handleRemove: (value: string) => void;
}

const VoucherList: React.SFC<IOwnProps> = ({ vouchers, removeLabel, handleRemove }) => {
  return (
    <div className={Styles.list}>
      {vouchers && vouchers.length > 0 && vouchers.map((voucher) => {
        const { voucher: voucherCode, priceOff } = voucher;

        return (
          <div key={voucherCode} className={Styles.item}>
            <div className={Styles.voucher}><span className={Styles.priceOff}>{priceOff}</span> <span className={Styles.code}>{voucherCode}</span></div>
            <div className={Styles.remove}>
              <Button align="left" type="button" label={removeLabel} size="small" variant="clear" onClick={() => { handleRemove(voucherCode); }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VoucherList;
